function maxfromat() {
  let date = new Date();
  let year = date.getFullYear();
  let day = date.getDate();
  let month = date.getMonth() + 1;
  if (month.toString().length === 1) {
    month = `0${month}`;
  }
  if (day.toString().length === 1) {
    day = `0${day}`;
  }
  return `${year}-${month}-${day}`;
}

function getFirstDayOfMonth() {
const d = new Date()
let year = d.getFullYear()
let month = d.getMonth() + 1
if (month.toString().length === 1) {
    month = `0${month}`;
}
return `${year}-${month}-01`;
}

export {maxfromat, getFirstDayOfMonth}